(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-with-text"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function() {
    // スマホの場合のみ動作
    if (window.innerWidth <= 989) {
        $(".gallery-with-text__wrapper").on("scroll", function() {
            var $this = $(this);
            if ($this.scrollLeft() + $this.innerWidth() >= $this[0].scrollWidth) {
                $this.scrollLeft(0);
            }
        });
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-sticky');
		};

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.headerBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.header);
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		this.disclosures.forEach(disclosure => disclosure.close());
	}

	closeSearchModal() {
		this.searchModal = this.searchModal || this.header.querySelector('details-modal');
		this.searchModal.close(false);
	}
}

customElements.define('sticky-header', StickyHeader);

const searchDetails = document.querySelector('.header__search details');
document.addEventListener('keyup', (e) => {
	if (e.key === 'Escape' && searchDetails) {
		searchDetails.removeAttribute('open');
	}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    


// ========================================
// カート小計が15000円以上の場合の入力フォーム制御（期間限定版）
// ========================================

async function checkCartTotalAndShowForm() {
  try {
    const cart = await getCart();
    if (!cart) return;
    
    // ========================================
    // 期間チェック：2026年1月14日（水）のみ表示
    // ========================================
    const now = new Date();
    
    // 日本時間に変換（UTC+9）
    const jstOffset = 9 * 60; // 9時間（分単位）
    const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
    const jstTime = new Date(utcTime + (jstOffset * 60000));
    
    const year = jstTime.getFullYear();
    const month = jstTime.getMonth() + 1; // 0-indexed
    const date = jstTime.getDate();
    
    console.log(`現在の日本時間: ${year}年${month}月${date}日 ${jstTime.getHours()}:${jstTime.getMinutes()}`);
    
    // 2026年1月14日かチェック
    const isTargetDate = (year === 2026 && month === 1 && date === 14);
    
    if (!isTargetDate) {
      console.log('キャンペーン期間外のため、会員番号フォームを非表示');
      const formContainer = document.getElementById('high-value-order-form');
      if (formContainer) {
        formContainer.style.display = 'none';
      }
      return;
    }
    
    console.log('✓ キャンペーン期間内（2026年1月14日）');
    
    // ========================================
    // 金額チェック：15000円以上
    // ========================================
    const subtotal = cart.total_price / 100; // 円単位に変換
    
    console.log(`カート小計: ${subtotal}円`);
    
    const formContainer = document.getElementById('high-value-order-form');
    if (!formContainer) return;
    
    // 15000円以上の場合、フォームを表示
    if (subtotal >= 15000) {
      formContainer.style.display = 'block';
      console.log('15000円以上のため、会員番号フォームを表示');
      
      // 既存のattributesから情報を復元
      await restoreReferenceNumber(cart.attributes);
    } else {
      formContainer.style.display = 'none';
      console.log('15000円未満のため、会員番号フォームを非表示');
    }
  } catch (error) {
    console.error('カート金額のチェックに失敗:', error);
  }
}

// カートのattributesから会員番号を復元
async function restoreReferenceNumber(attributes) {
  if (!attributes) return;
  
  try {
    const referenceNumberInput = document.getElementById('order-reference-number');
    if (!referenceNumberInput) return;
    
    // attributesから会員番号を取得
    if (attributes['会員番号']) {
      referenceNumberInput.value = attributes['会員番号'];
      console.log('会員番号を復元しました:', attributes['会員番号']);
    }
  } catch (error) {
    console.error('会員番号の復元に失敗:', error);
  }
}




// 特典のマッピング設定
const giftProductMapping = {
  //'wada': {
  //  'osaka': {
  //    'handle': '30_book_osaka_1-4',
  //    'variants': {
  //      '1': 49664728203559,  // お見送り会チケット
  //      '2': 49664728236327,  // じゃんけん会チケット
  //      '4': 49664728269095   // サイン会チケット
  //    }
  //  },
  //  'tokyo': {
  //    'handle': '30_book_tokyo_1-4',
  //    'variants': {
  //      '1': 49664738132263,
  //      '2': 49664738165031,
  //      '4': 49664738197799
  //    }
  //  }
  //},
  'iwaoka': {
    'osaka': {
      'handle': 'ti26_osaka_1-5',
      'variants': {
        '1': 50892259000615,
        '3': 50892259033383,
        '5': 50892259066151
      }
    },
    'tokyo': {
      'handle': 'ti26_tokyo_1-5',
      'variants': {
        '1': 50902086320423,
        '3': 50902086353191,
        '5': 50902086385959
      }
    },
    'fukuoka': {
      'handle': 'ti26_fukuoka_1-5',
      'variants': {
        '1': 50902832840999,
        '3': 50902832873767,
        '5': 50902832906535
      }
    }
  },
  'iwaoka2': {  // 2日目用に新しいアーティストキーを追加
    'osaka': {
      'handle': 'ti26_osaka_day2_1-5',
      'variants': {
        '1': 50892370215207,
        '3': 50892370247975,
        '5': 50892370280743
      }
    },
    'tokyo': {
      'handle': 'ti26_tokyo_day2_1-5',
      'variants': {
        '1': 50902432710951,  // 実際のバリアントIDに置き換え
        '3': 50902432743719,
        '5': 50902432776487
      }
    }
  }
//  'ohno': {
//    'osaka': {
//      'handle': 'ohno_osaka_1-4',
//      'variants': {
//        '1': 49877812445479,
//        '2': 49877812478247,
//        '4': 49877812511015
//      }
//    },
//    'tokyo': {
//      'handle': 'ohno_tokyo_1-4',
//      'variants': {
//        '1': 49877812936999,
//        '2': 49877812969767,
//        '4': 49877813002535
//      }
//    }
//  }
};

const EXCLUDED_VARIANT_IDS = [
  50894569013543, // 大阪会場1日目＋カレンダーA
  50894569046311, // 大阪会場1日目＋カレンダーB
  50894569079079, // 大阪会場1日目＋カレンダーC
  50894569111847, // 大阪会場1日目＋カレンダーD
  50894569144615, // 大阪会場1日目＋カレンダーD
  50894569177383, // 大阪会場1日目＋カレンダーF

  50900113522983, // 大阪会場2日目＋カレンダーA
  50900113555751, // 大阪会場2日目＋カレンダーB
  50900113588519, // 大阪会場2日目＋カレンダーC
  50900113621287, // 大阪会場2日目＋カレンダーD
  50900113654055, // 大阪会場2日目＋カレンダーD
  50900113686823, // 大阪会場2日目＋カレンダーF

  50902703341863, // 東京会場1日目＋カレンダーA
  50902703374631, // 東京会場1日目＋カレンダーB
  50902703407399, // 東京会場1日目＋カレンダーC
  50902703440167, // 東京会場1日目＋カレンダーD
  50902703472935, // 東京会場1日目＋カレンダーD
  50902703505703, // 東京会場1日目＋カレンダーF

  50902781067559, // 東京会場2日目＋カレンダーA
  50902781100327, // 東京会場2日目＋カレンダーB
  50902781133095, // 東京会場2日目＋カレンダーC
  50902781165863, // 東京会場2日目＋カレンダーD
  50902781198631, // 東京会場2日目＋カレンダーD
  50902781231399, // 東京会場2日目＋カレンダーF

  50902899261735, // 福岡会場＋カレンダーA
  50902899294503, // 福岡会場＋カレンダーB
  50902899327271, // 福岡会場＋カレンダーC
  50902899360039, // 福岡会場＋カレンダーD
  50902899392807, // 福岡会場＋カレンダーD
  50902899425575, // 福岡会場＋カレンダーF

  // ★ 除外したい商品のバリアントIDをここに追加
  // バリアントIDの確認方法は上記参照
];


// ★★★ 自動追加商品のバリアントID ★★★
const AUTO_ADD_PRODUCTS = {
  'iwaoka-osaka': 50894625079591,  // 大阪会場1日目用の自動追加商品
  'iwaoka2-osaka': 50894634090791,  // 大阪会場2日目用の自動追加商品
  'iwaoka-tokyo': 50902086418727,  // 東京会場1日目用の自動追加商品
  'iwaoka2-tokyo': 50902432809255,  // 東京会場2日目用の自動追加商品
  'iwaoka-fukuoka': 50902832939303,  // 福岡会場2日目用の自動追加商品
};

// ========================================
// カレンダー付き商品のバリアントID定義（グローバル）
// ========================================

const CALENDAR_VARIANTS = {
  'iwaoka-osaka': [
    50894569013543, 50894569046311, 50894569079079,
    50894569111847, 50894569144615, 50894569177383
  ],
  'iwaoka2-osaka': [
    50900113522983, 50900113555751, 50900113588519,
    50900113621287, 50900113654055, 50900113686823
  ],
  'iwaoka-tokyo': [
    50902703341863, 50902703374631, 50902703407399,
    50902703440167, 50902703472935, 50902703505703
  ],
  'iwaoka2-tokyo': [
    50902781067559, 50902781100327, 50902781133095,
    50902781165863, 50902781198631, 50902781231399
  ],
  'iwaoka-fukuoka': [
    50902899261735, 50902899294503, 50902899327271,
    50902899360039, 50902899392807, 50902899425575
  ]
};

// ========================================
// カート内のカレンダー付き商品を検出
// ========================================

async function detectCalendarProductsInCart() {
  try {
    const cart = await getCart();
    if (!cart || !cart.items) return {};
    
    const calendarProducts = {
      'iwaoka-osaka': false,
      'iwaoka2-osaka': false,
      'iwaoka-tokyo': false,
      'iwaoka2-tokyo': false,
      'iwaoka-fukuoka': false
    };
    
    cart.items.forEach(item => {
      for (const [venue, variantIds] of Object.entries(CALENDAR_VARIANTS)) {
        if (variantIds.includes(item.variant_id)) {
          calendarProducts[venue] = true;
          console.log(`カレンダー付き商品を検出: ${venue} - ${item.title}`);
        }
      }
    });
    
    return calendarProducts;
  } catch (error) {
    console.error('カレンダー付き商品の検出に失敗:', error);
    return {};
  }
}


// 在庫情報のキャッシュ
const inventoryCache = {
  data: {},
  timestamp: {},
  CACHE_DURATION: 30000,
  
  set(key, value) {
    this.data[key] = value;
    this.timestamp[key] = Date.now();
  },
  
  get(key) {
    if (!this.data[key]) return null;
    const age = Date.now() - this.timestamp[key];
    if (age > this.CACHE_DURATION) {
      delete this.data[key];
      delete this.timestamp[key];
      return null;
    }
    return this.data[key];
  },
  
  clear() {
    this.data = {};
    this.timestamp = {};
  }
};

// ========================================
// 2. ヘルパー関数（グローバルスコープ）
// ========================================

async function checkGiftInventory(artist, location, type) {
  const cacheKey = `${artist}-${location}-${type}`;
  
  const cached = inventoryCache.get(cacheKey);
  if (cached) {
    console.log(`キャッシュから在庫情報を取得: ${cacheKey}`);
    return cached;
  }
  
  try {
    if (!giftProductMapping[artist]?.[location]?.variants?.[type]) {
      console.warn(`バリアントIDが見つかりません: ${artist}, ${location}, ${type}`);
      return { available: false, inventory: 0, managed: false };
    }
    
    const variantId = giftProductMapping[artist][location].variants[type];
    
    if (variantId === 0 || variantId < 1000) {
      console.warn(`無効なバリアントID: ${artist}-${location} タイプ:${type} (ID: ${variantId})`);
      return { available: false, inventory: 0, managed: false };
    }
    
    console.log(`在庫チェック: ${artist}-${location} タイプ:${type} バリアントID:${variantId}`);
    
    // ★★★ Liquidから渡されたデータを優先的に使用 ★★★
    if (window.giftInventoryData && window.giftInventoryData[variantId]) {
      const data = window.giftInventoryData[variantId];
      
      const result = {
        available: data.available,
        inventory: data.inventory,
        managed: data.managed
      };
      
      inventoryCache.set(cacheKey, result);
      console.log(`✓ Liquidデータから在庫取得: バリアントID=${variantId}, 在庫=${data.inventory}個, 利用可能=${data.available}`);
      return result;
    }
    
    // ★★★ フォールバック: APIから取得（在庫数は取得できないが、availableは取得可能）★★★
    console.warn(`Liquidデータが見つかりません。APIから取得します（在庫数は不正確になる可能性があります）`);
    
    const productHandle = giftProductMapping[artist][location].handle;
    const productResponse = await fetch(`/products/${productHandle}.js`);
    
    if (!productResponse.ok) {
      console.error(`商品情報の取得に失敗: ${productHandle}`, productResponse.status);
      return { available: false, inventory: 0, managed: false };
    }
    
    const productData = await productResponse.json();
    const variant = productData.variants.find(v => v.id === variantId);
    
    if (!variant) {
      console.error(`バリアントが見つかりません: ${variantId}`);
      return { available: false, inventory: 0, managed: false };
    }
    
    const isInventoryManaged = variant.inventory_management === 'shopify';
    const isAvailable = variant.available;
    
    // 在庫数が取得できないので、availableに基づいて推測
    const inventory = isAvailable ? 999 : 0;
    
    console.warn(`在庫数を正確に取得できませんでした。available=${isAvailable}に基づいて推測: ${inventory}`);
    
    const result = {
      available: isAvailable,
      inventory: inventory,
      managed: isInventoryManaged
    };
    
    inventoryCache.set(cacheKey, result);
    return result;
    
  } catch (error) {
    console.error('在庫チェックエラー:', error);
    return { available: false, inventory: 0, managed: false };
  }
}

async function preloadAllInventory() {
  console.log("全特典の在庫情報を一括読み込み中...");
  
  const loadPromises = [];
  let skippedCount = 0;
  
  for (const [artist, locations] of Object.entries(giftProductMapping)) {
    for (const [location, config] of Object.entries(locations)) {
      for (const type of Object.keys(config.variants)) {
        const variantId = config.variants[type];
        
        // ★ 無効なバリアントIDはスキップ
        if (!variantId || variantId === 0 || variantId < 1000) {
          console.warn(`スキップ: ${artist}-${location} タイプ:${type} (無効なバリアントID: ${variantId})`);
          skippedCount++;
          continue;
        }
        
        loadPromises.push(checkGiftInventory(artist, location, parseInt(type)));
      }
    }
  }
  
  await Promise.all(loadPromises);
  
  console.log(`在庫情報の一括読み込み完了 (読み込み: ${loadPromises.length}件, スキップ: ${skippedCount}件)`);
}


// ========================================
// カート情報取得（リトライ機能付き）
// ========================================
async function getCart(retries = 3, delay = 500) {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn(`カート取得試行 ${i + 1}/${retries} 失敗:`, error);
      
      if (i < retries - 1) {
        // リトライ前に待機
        await new Promise(resolve => setTimeout(resolve, delay));
      } else {
        // 最後のリトライでも失敗した場合はエラーをスロー
        throw error;
      }
    }
  }
}


async function updateCartCounter() {
  try {
    const cart = await getCart();
    if (cart && cart.item_count !== undefined) {
      const cartCounters = document.querySelectorAll('.cart-counter');
      cartCounters.forEach(counter => {
        counter.textContent = cart.item_count;
        if (cart.item_count > 0) {
          counter.classList.add('has-items');
        } else {
          counter.classList.remove('has-items');
        }
      });
    }
  } catch (error) {
    console.error('カート数量の更新に失敗:', error);
  }
}

async function updateVenueProductInfo() {
  try {
    console.log("=== 対象商品数量の更新を開始します ===");
    const cart = await getCart();
    if (!cart || !cart.items) {
      console.log("カート情報の取得に失敗または商品がありません");
      return;
    }
    
    console.log("カート情報:", cart.items.length + "個の商品");
    
    const venueProductCounts = {};
    const allPossibleVenues = [
      'iwaoka-tokyo', 'iwaoka-osaka', 'iwaoka-fukuoka',
      'iwaoka2-tokyo', 'iwaoka2-osaka',
      'wada-tokyo', 'wada-osaka',
      'ohno-tokyo', 'ohno-osaka'
    ];
    
    allPossibleVenues.forEach(venue => {
      venueProductCounts[venue] = 0;
    });
    
    console.log("=== カート内容の詳細 ===");
    cart.items.forEach((item, index) => {
      console.log(`商品[${index}]:`, 
                  `ID: ${item.id}`,
                  `バリアントID: ${item.variant_id}`,
                  `タイトル: ${item.title}`, 
                  `数量: ${item.quantity}`,
                  `タグ:`, item.tags);
    });
    
    cart.items.forEach(item => {
      if (EXCLUDED_VARIANT_IDS.includes(item.variant_id)) {
        console.log(`✗ 除外対象商品: ${item.title} (バリアントID: ${item.variant_id})`);
        return;
      }

      const tags = item.tags || [];
      let matched = false;
      
      // ========================================
      // タグベースのマッチング（優先）
      // ========================================
      
      // 岩岡徹 2日目（先にチェック）
      if (!matched && tags.some(tag => tag.includes('岩岡徹-東京-2日目'))) {
        venueProductCounts['iwaoka2-tokyo'] += item.quantity;
        console.log(`✓ 岩岡徹-東京(2日目): ${item.title}, 数量: ${item.quantity}`);
        matched = true;
      }
      if (!matched && tags.some(tag => tag.includes('岩岡徹-大阪-2日目'))) {
        venueProductCounts['iwaoka2-osaka'] += item.quantity;
        console.log(`✓ 岩岡徹-大阪(2日目): ${item.title}, 数量: ${item.quantity}`);
        matched = true;
      }
      
      // 岩岡徹 1日目
      if (!matched && tags.some(tag => tag.includes('岩岡徹-東京-1日目'))) {
        venueProductCounts['iwaoka-tokyo'] += item.quantity;
        console.log(`✓ 岩岡徹-東京(1日目): ${item.title}, 数量: ${item.quantity}`);
        matched = true;
      }
      if (!matched && tags.some(tag => tag.includes('岩岡徹-大阪-1日目'))) {
        venueProductCounts['iwaoka-osaka'] += item.quantity;
        console.log(`✓ 岩岡徹-大阪(1日目): ${item.title}, 数量: ${item.quantity}`);
        matched = true;
      }
      if (!matched && tags.some(tag => tag.includes('岩岡徹-福岡'))) {
        venueProductCounts['iwaoka-fukuoka'] += item.quantity;
        console.log(`✓ 岩岡徹-福岡: ${item.title}, 数量: ${item.quantity}`);
        matched = true;
      }
      
      // 和田颯
      if (!matched && tags.some(tag => tag.includes('和田颯') || tag.includes('wada'))) {
        if (tags.some(tag => tag.includes('東京') || tag.includes('tokyo'))) {
          venueProductCounts['wada-tokyo'] += item.quantity;
          console.log(`✓ 和田颯-東京: ${item.title}, 数量: ${item.quantity}`);
          matched = true;
        } else if (tags.some(tag => tag.includes('大阪') || tag.includes('osaka'))) {
          venueProductCounts['wada-osaka'] += item.quantity;
          console.log(`✓ 和田颯-大阪: ${item.title}, 数量: ${item.quantity}`);
          matched = true;
        }
      }
      
      // 大野雄大
      if (!matched && tags.some(tag => tag.includes('大野雄大') || tag.includes('ohno'))) {
        if (tags.some(tag => tag.includes('東京') || tag.includes('tokyo'))) {
          venueProductCounts['ohno-tokyo'] += item.quantity;
          console.log(`✓ 大野雄大-東京: ${item.title}, 数量: ${item.quantity}`);
          matched = true;
        } else if (tags.some(tag => tag.includes('大阪') || tag.includes('osaka'))) {
          venueProductCounts['ohno-osaka'] += item.quantity;
          console.log(`✓ 大野雄大-大阪: ${item.title}, 数量: ${item.quantity}`);
          matched = true;
        }
      }
      
      // ========================================
      // タイトルベースのマッチング（フォールバック）
      // ========================================
      if (!matched) {
        const title = item.title;
        
        // 岩岡徹の商品を日付で識別
        if (title.includes('岩岡徹')) {
          // 大阪 1日目: 4/4(土)大阪会場
          if (title.includes('【4/4(土)大阪会場】') || title.includes('【4/4(土) 大阪会場】')) {
            venueProductCounts['iwaoka-osaka'] += item.quantity;
            console.log(`タイトルから岩岡徹-大阪会場(1日目)の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
          // 大阪 2日目: 4/5(日)大阪会場
          else if (title.includes('【4/5(日)大阪会場】') || title.includes('【4/5(日) 大阪会場】')) {
            venueProductCounts['iwaoka2-osaka'] += item.quantity;
            console.log(`タイトルから岩岡徹-大阪会場(2日目)の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
          // 東京 1日目: 3/28(土)東京会場
          else if (title.includes('【3/28(土)東京会場】') || title.includes('【3/28(土) 東京会場】')) {
            venueProductCounts['iwaoka-tokyo'] += item.quantity;
            console.log(`タイトルから岩岡徹-東京会場(1日目)の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
          // 東京 2日目: 5/17(土)東京会場
          else if (title.includes('【5/17(日)東京会場】') || title.includes('【5/17(土) 東京会場】')) {
            venueProductCounts['iwaoka2-tokyo'] += item.quantity;
            console.log(`タイトルから岩岡徹-東京会場(2日目)の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
          // 福岡: 5/9(土)福岡会場
          else if (title.includes('【5/9(土)福岡会場】') || title.includes('【5/9(土) 福岡会場】')) {
            venueProductCounts['iwaoka-fukuoka'] += item.quantity;
            console.log(`タイトルから岩岡徹-福岡会場の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
          // 日付情報がない場合の旧形式フォールバック
          else if (title.includes('1日目')) {
            if (title.includes('東京')) {
              venueProductCounts['iwaoka-tokyo'] += item.quantity;
              console.log(`タイトルから岩岡徹-東京会場(1日目)の商品を推測(旧形式): ${title}, 数量: ${item.quantity}`);
              matched = true;
            } else if (title.includes('大阪')) {
              venueProductCounts['iwaoka-osaka'] += item.quantity;
              console.log(`タイトルから岩岡徹-大阪会場(1日目)の商品を推測(旧形式): ${title}, 数量: ${item.quantity}`);
              matched = true;
            }
          } else if (title.includes('2日目')) {
            if (title.includes('東京')) {
              venueProductCounts['iwaoka2-tokyo'] += item.quantity;
              console.log(`タイトルから岩岡徹-東京会場(2日目)の商品を推測(旧形式): ${title}, 数量: ${item.quantity}`);
              matched = true;
            } else if (title.includes('大阪')) {
              venueProductCounts['iwaoka2-osaka'] += item.quantity;
              console.log(`タイトルから岩岡徹-大阪会場(2日目)の商品を推測(旧形式): ${title}, 数量: ${item.quantity}`);
              matched = true;
            }
          } else if (title.includes('福岡')) {
            venueProductCounts['iwaoka-fukuoka'] += item.quantity;
            console.log(`タイトルから岩岡徹-福岡会場の商品を推測(旧形式): ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
        }
        // 和田颯
        else if (title.includes('和田颯') || title.includes('Wada') || title.includes('WADA')) {
          if (title.includes('東京')) {
            venueProductCounts['wada-tokyo'] += item.quantity;
            console.log(`タイトルから和田颯-東京会場の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          } else if (title.includes('大阪')) {
            venueProductCounts['wada-osaka'] += item.quantity;
            console.log(`タイトルから和田颯-大阪会場の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
        }
        // 大野雄大
        else if (title.includes('大野雄大') || title.includes('OHNO') || title.includes('Ohno')) {
          if (title.includes('東京')) {
            venueProductCounts['ohno-tokyo'] += item.quantity;
            console.log(`タイトルから大野雄大-東京会場の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          } else if (title.includes('大阪')) {
            venueProductCounts['ohno-osaka'] += item.quantity;
            console.log(`タイトルから大野雄大-大阪会場の商品を推測: ${title}, 数量: ${item.quantity}`);
            matched = true;
          }
        }
      }
      
      if (!matched) {
        console.log(`? マッチしない商品: ${item.title}`);
      }
    });
    
    console.log("=== 商品数集計結果 ===");
    Object.entries(venueProductCounts).forEach(([venue, count]) => {
      if (count > 0) {
        console.log(`${venue}: ${count}冊`);
      }
    });
    
    document.querySelectorAll('.venue-gifts').forEach(venueElement => {
      const venue = venueElement.dataset.venue;
      if (!venue) return;
      
      const infoElement = venueElement.querySelector('.venue-product-info:last-of-type');
      if (infoElement) {
        const count = venueProductCounts[venue] || 0;
        infoElement.textContent = `対象商品数量: ${count}冊`;
        console.log(`表示更新: ${venue} = ${count}冊`);
        
        venueElement.dataset.quantity = count;
        window.venueQuantities[venue] = count;
      }
    });
    
    for (const venue of Object.keys(venueProductCounts)) {
      if (venueProductCounts[venue] > 0 && document.querySelector(`[data-venue="${venue}"]`)) {
        await updateButtonStates(venue);
      }
    }
    
    console.log("=== 対象商品数量の更新完了 ===");
  } catch (error) {
    console.error('対象商品数量の更新に失敗:', error);
  }
}

function getAllTicketVariantIds() {
  const variantIds = new Set();
  
  // 特典チケットのバリアントID
  Object.values(giftProductMapping).forEach(locations => {
    Object.values(locations).forEach(location => {
      Object.values(location.variants).forEach(variantId => {
        variantIds.add(variantId.toString());
      });
    });
  });
  
  // ★★★ 自動追加商品のバリアントIDも追加 ★★★
  Object.values(AUTO_ADD_PRODUCTS).forEach(variantId => {
    variantIds.add(variantId.toString());
  });
  
  return Array.from(variantIds);
}

// ========================================
// カート内のチケットをクリーンアップ（デバッグ強化版）
// ========================================
async function cleanupTicketsInCart() {
  try {
    console.log('=== チケットクリーンアップ開始 ===');
    
    // カート情報を取得
    let cart;
    try {
      cart = await getCart();
    } catch (error) {
      console.warn('カート情報の取得に失敗しました。クリーンアップをスキップします。', error);
      return;
    }
    
    if (!cart || !cart.items || cart.items.length === 0) {
      console.log('カートが空です。クリーンアップ不要。');
      return;
    }
    
    console.log(`カート内の全商品: ${cart.items.length}個`);
    cart.items.forEach((item, index) => {
      console.log(`  [${index}] ${item.title} (ID: ${item.id}, バリアントID: ${item.variant_id})`);
    });
    
    // すべてのチケットバリアントIDを取得
    const allTicketVariantIds = getAllTicketVariantIds();
    console.log('チケットバリアントIDリスト:', allTicketVariantIds);
    console.log('チケットバリアントID数:', allTicketVariantIds.length);
    
    // カート内のチケットを検索
    const ticketsInCart = cart.items.filter(item => {
      const isTicket = allTicketVariantIds.includes(item.variant_id);
      if (isTicket) {
        console.log(`✓ チケット検出: ${item.title} (バリアントID: ${item.variant_id})`);
      }
      return isTicket;
    });
    
    // 削除対象外の商品も表示
    const nonTickets = cart.items.filter(item => !allTicketVariantIds.includes(item.variant_id));
    if (nonTickets.length > 0) {
      console.log('削除対象外の商品:');
      nonTickets.forEach(item => {
        console.log(`  ✓ ${item.title} (バリアントID: ${item.variant_id})`);
      });
    }
    
    if (ticketsInCart.length === 0) {
      console.log('カート内にチケットはありません');
      return;
    }
    
    console.log(`削除対象のチケット: ${ticketsInCart.length}個`);
    ticketsInCart.forEach(ticket => {
      console.log(`  - ${ticket.title}`);
    });
    
    // チケットを削除（数量を0に設定）
    const updates = {};
    ticketsInCart.forEach(ticket => {
      updates[ticket.id] = 0;
      console.log(`削除予定: ID=${ticket.id}, タイトル=${ticket.title}`);
    });
    
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      if (!response.ok) {
        throw new Error(`カート更新失敗: ${response.status}`);
      }
      
      const result = await response.json();
      console.log('✓ チケットのクリーンアップ完了');
      console.log('クリーンアップ後のカート:', result.items.length + '個の商品');
      result.items.forEach(item => {
        console.log(`  - ${item.title}`);
      });
      
    } catch (updateError) {
      // 更新に失敗した場合は、個別に削除を試みる
      console.warn('一括更新に失敗。個別削除を試みます。', updateError);
      
      for (const ticket of ticketsInCart) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: ticket.id,
              quantity: 0
            })
          });
          console.log(`✓ チケット削除: ${ticket.title}`);
        } catch (deleteError) {
          console.warn(`チケット削除失敗: ${ticket.title}`, deleteError);
        }
      }
    }
    
    console.log('=== チケットクリーンアップ完了 ===');
    
  } catch (error) {
    console.error('チケットのクリーンアップに失敗:', error);
    console.log('処理を続行します...');
  }
}

function getVenueInputs(venue) {
  if (venue.startsWith('iwaoka2') || venue.startsWith('iwaoka')) {
    return {
      gift5: document.getElementById(`${venue}-gift-5`),
      gift3: document.getElementById(`${venue}-gift-3`),
      gift1: document.getElementById(`${venue}-gift-1`)
    };
  } else if (venue.startsWith('ohno')) {
    return {
      gift4: document.getElementById(`${venue}-gift-4`),
      gift2: document.getElementById(`${venue}-gift-2`),
      gift1: document.getElementById(`${venue}-gift-1`)
    };
  } else {
    return {
      gift4: document.getElementById(`${venue}-gift-4`),
      gift2: document.getElementById(`${venue}-gift-2`),
      gift1: document.getElementById(`${venue}-gift-1`)
    };
  }
}

function calculateRemaining(venue) {
  const inputs = getVenueInputs(venue);
  const multipliers = venue.startsWith('iwaoka') ? [5, 3, 1] : [4, 2, 1];
  
  const values = Object.values(inputs).map(input => {
    if (!input) return 0;
    return parseInt(input.value) || 0;
  });
  
  console.log(`${venue}の残り冊数計算:`, 
              `合計=${window.venueQuantities[venue] || 0}冊`, 
              `選択値=[${values.join(', ')}]`, 
              `乗数=[${multipliers.join(', ')}]`);
  
  const totalSelected = values.reduce((sum, val, idx) => {
    const contribution = val * multipliers[idx];
    console.log(`選択${idx+1}: ${val} × ${multipliers[idx]} = ${contribution}`);
    return sum + contribution;
  }, 0);
  
  const totalQuantity = window.venueQuantities[venue] || 0;
  const remaining = totalQuantity - totalSelected;
  
  console.log(`${venue}の計算結果: 合計${totalQuantity}冊 - 選択中${totalSelected}冊 = 残り${remaining}冊`);
  
  return remaining;
}

async function updateButtonStates(venue) {
  const inputs = getVenueInputs(venue);
  const remaining = calculateRemaining(venue);
  const [artist, location] = venue.split('-');

  console.log(`${venue}のボタン状態を更新します。残り${remaining}冊分`);

  for (const [key, input] of Object.entries(inputs)) {
    const type = parseInt(key.replace('gift', ''));
    const decreaseBtn = input.previousElementSibling;
    const increaseBtn = input.nextElementSibling;
    const statusSpan = document.querySelector(`[data-gift-id="${venue}-gift-${type}"]`);

    const inventory = await checkGiftInventory(artist, location, type);
    const currentValue = parseInt(input.value) || 0;

    decreaseBtn.disabled = currentValue <= 0;
    increaseBtn.disabled = remaining < type || !inventory.available;

    if (statusSpan) {
      console.log(`${venue}-gift-${type} 在庫状況を更新:`, 
                  `在庫状態=${inventory.available}`, 
                  `在庫数=${inventory.inventory}`,
                  `残り=${remaining}`, 
                  `現在値=${currentValue}`);

      // 既存のクラスをリセット
      statusSpan.classList.remove('out-of-stock', 'low-stock', 'very-low-stock');
      statusSpan.textContent = '';
      
      // 優先順位順にチェック
      if (!inventory.available) {
        statusSpan.textContent = 'チケット在庫切れ';
        statusSpan.classList.add('out-of-stock');
      } 
      else if (remaining < type && currentValue === 0) {
        statusSpan.textContent = `${type}冊必要（${remaining}冊分の特典が選択可能）`;
        statusSpan.classList.add('out-of-stock');
      } 
      else if (remaining === 0 && currentValue === 0) {
        statusSpan.textContent = '選択できません';
        statusSpan.classList.add('out-of-stock');
      }
      // ★★★ 在庫警告を追加 ★★★
      else if (inventory.managed && inventory.inventory > 0) {
        if (inventory.inventory <= 3) {
          // 在庫3個以下：赤色で緊急警告
          statusSpan.textContent = `残りチケット ${inventory.inventory}枚`;
          statusSpan.classList.add('very-low-stock');
        } else if (inventory.inventory <= 10) {
          // 在庫10個以下：黄色で警告
          statusSpan.textContent = `残りチケット ${inventory.inventory}枚`;
          statusSpan.classList.add('low-stock');
        }
        // 在庫11個以上：何も表示しない（正常）
      }
    } else {
      console.warn(`${venue}-gift-${type} の表示要素が見つかりません`);
    }
  }
}

function validateName(name, requireKatakana = true) {
  if (!name || typeof name !== 'string') {
    return false;
  }
  
  const trimmedName = name.trim().replace(/^[\s　]+|[\s　]+$/g, '');
  const nameParts = trimmedName.split(/[\s　]+/);
  
  if (nameParts.length !== 2 || nameParts[0].trim().length === 0 || nameParts[1].trim().length === 0) {
    return false;
  }
  
  if (requireKatakana) {
    const fullWidthKatakanaPattern = /^[ァ-ヶーヽヾ]+$/;
    const halfWidthKatakanaPattern = /^[ｦ-ﾟ-]+$/;
    
    return (fullWidthKatakanaPattern.test(nameParts[0]) || halfWidthKatakanaPattern.test(nameParts[0])) &&
           (fullWidthKatakanaPattern.test(nameParts[1]) || halfWidthKatakanaPattern.test(nameParts[1]));
  }
  
  return true;
}

async function removeTicketsFromCart() {
  try {
    console.log("Debug - チケットのクリーンアップを開始");
    const cart = await getCart();
    const ticketVariantIds = new Set(getAllTicketVariantIds());

    const updates = {};
    let hasTickets = false;
    
    cart.items.forEach(item => {
      if (ticketVariantIds.has(item.variant_id.toString())) {
        hasTickets = true;
        updates[item.variant_id] = 0;
      }
    });

    if (hasTickets) {
      console.log("Debug - 既存のチケットを削除します");
      const result = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      
      if (!result.ok) {
        throw new Error('チケットの削除に失敗しました');
      }
      
      return await result.json();
    }
    
    return cart;
  } catch (error) {
    console.error('チケット削除中にエラーが発生:', error);
    throw error;
  }
}

function setupNameInputs() {
  const nameInputs = [
    { id: 'iwaoka-representative-name', label: '岩岡徹（1日目）', requireKatakana: true },
    { id: 'iwaoka2-representative-name', label: '岩岡徹（2日目）', requireKatakana: true },
    { id: 'wada-representative-name', label: '和田颯', requireKatakana: true },
    { id: 'ohno-representative-name', label: '大野雄大', requireKatakana: true }
  ];
  
  nameInputs.forEach(({id, requireKatakana}) => {
    const input = document.getElementById(id);
    if (!input) return;
    
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.textContent = requireKatakana 
      ? 'カタカナで入力してください（姓と名の間にスペース）' 
      : '姓と名の間にスペースを入れてください';
    errorDiv.style.display = 'none';
    input.parentNode.insertBefore(errorDiv, input.nextElementSibling.nextSibling);
    
    input.addEventListener('compositionend', function() {
      const isValid = validateName(this.value, requireKatakana);
      errorDiv.style.display = isValid ? 'none' : 'block';
    });
    
    input.addEventListener('input', function(e) {
      if (e.isComposing) return;
      const isValid = validateName(this.value, requireKatakana);
      errorDiv.style.display = isValid ? 'none' : 'block';
    });
    
    input.addEventListener('blur', function() {
      const isValid = validateName(this.value, requireKatakana);
      errorDiv.style.display = isValid ? 'none' : 'block';
    });
  });
}

function setupGiftButtons() {
  document.querySelectorAll('.number-spinner button').forEach(button => {
    button.addEventListener('click', async function(event) {
      event.preventDefault();
      
      const venue = this.getAttribute('data-venue');
      const type = parseInt(this.getAttribute('data-type'));
      const isIncrease = this.classList.contains('increase');
      
      const input = document.getElementById(`${venue}-gift-${type}`);
      if (!input) return;
      
      const currentValue = parseInt(input.value) || 0;
      
      if (isIncrease) {
        const [artist, location] = venue.split('-');
        const inventory = await checkGiftInventory(artist, location, type);
        
        if (inventory.managed && currentValue >= inventory.inventory) {
          console.log(`${venue}-gift-${type}: 在庫上限（${inventory.inventory}）に達しているため増加できません`);
          return;
        }
      }
      
      const newValue = isIncrease ? currentValue + 1 : Math.max(0, currentValue - 1);
      input.value = newValue;
      
      await updateButtonStates(venue);
    });
  });
}

function enhanceInventoryDisplay() {
  if (document.getElementById('inventory-display-styles')) {
    return;
  }
  
  const style = document.createElement('style');
  style.id = 'inventory-display-styles';
  style.textContent = `
    .inventory-status {
      display: inline-block;
      margin: 0 8px;
      font-size: 12px;
      color: #666;
      padding: 2px 8px;
      border-radius: 4px;
      font-weight: normal;
    }
    
    /* 在庫切れ（赤背景） */
    .inventory-status.out-of-stock {
      color: #fff;
      background-color: #dc3545;
      font-weight: bold;
    }
    
    /* 在庫3個以下（オレンジ背景・点滅） */
    .inventory-status.very-low-stock {
      color: #fff;
      background-color: #fd7e14;
      font-weight: bold;
      border: 2px solid #dc3545;
    }
    
    /* 在庫10個以下（黄色背景） */
    .inventory-status.low-stock {
      color: #856404;
      background-color: #fff3cd;
      font-weight: bold;
      border: 1px solid #ffc107;
    }
    
    .venue-gifts.has-stock-issues::before {
      content: "在庫に問題があります";
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: #dc3545;
      color: white;
      padding: 2px 8px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: bold;
    }
  `;
  document.head.appendChild(style);
}


function setupCartChangeDetection() {
  let lastCartState = null;
  let cartPollingTimer = null;
  
  async function pollCartChanges() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (lastCartState) {
        const itemsChanged = JSON.stringify(lastCartState.items) !== JSON.stringify(cart.items);
        const priceChanged = lastCartState.total_price !== cart.total_price;
        
        if (itemsChanged || priceChanged) {
          console.log('カートの内容または金額が変更されました');
          updateVenueProductInfo();
          checkCartTotalAndShowForm(); // ★ フォーム表示も更新
        }
      }
      
      lastCartState = cart;
    } catch (error) {
      console.error('カート変更の検出に失敗:', error);
    }
    
    cartPollingTimer = setTimeout(pollCartChanges, 2000);
  }
  
  pollCartChanges();
  
  document.querySelectorAll('.cart-item-quantity-button').forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => updateVenueProductInfo(), 500);
    });
  });
  
  document.querySelectorAll('.cart-item-remove').forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => updateVenueProductInfo(), 500);
    });
  });
  
  document.addEventListener('product:added', () => {
    updateVenueProductInfo();
  });
  
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      setTimeout(() => updateVenueProductInfo(), 1000);
    });
  });
  
  window.addEventListener('beforeunload', () => {
    if (cartPollingTimer) {
      clearTimeout(cartPollingTimer);
    }
  });
}


// ========================================
// カレンダー付き商品の情報を表示
// ========================================
async function displayCalendarProductsInfo(calendarProducts) {
  const infoContainer = document.getElementById('calendar-products-info');
  const listContainer = document.getElementById('calendar-products-list');
  
  if (!infoContainer || !listContainer) {
    console.warn('カレンダー商品情報のコンテナが見つかりません');
    return;
  }
  
  // カレンダー付き商品があるかチェック
  const hasAnyCalendar = Object.values(calendarProducts).some(v => v);
  
  if (!hasAnyCalendar) {
    infoContainer.style.display = 'none';
    return;
  }
  
  // カート情報を取得
  const cart = await getCart();
  if (!cart || !cart.items) return;
  
  // カレンダー付き商品のリストを生成
  const calendarItemsHTML = [];
  
  const venueMap = {
    'iwaoka-osaka': { 
      name: '岩岡徹 大阪会場（1日目）', 
      variants: [50894569013543, 50894569046311, 50894569079079, 50894569111847, 50894569144615, 50894569177383] 
    },
    'iwaoka2-osaka': { 
      name: '岩岡徹 大阪会場（2日目）', 
      variants: [50900113522983, 50900113555751, 50900113588519, 50900113621287, 50900113654055, 50900113686823] 
    },
    'iwaoka-tokyo': { 
      name: '岩岡徹 東京会場（1日目）', 
      variants: [50902703341863, 50902703374631, 50902703407399, 50902703440167, 50902703472935, 50902703505703] 
    },
    'iwaoka2-tokyo': { 
      name: '岩岡徹 東京会場（2日目）', 
      variants: [50902781067559, 50902781100327, 50902781133095, 50902781165863, 50902781198631, 50902781231399] 
    },
    'iwaoka-fukuoka': { 
      name: '岩岡徹 福岡会場', 
      variants: [50902899261735, 50902899294503, 50902899327271, 50902899360039, 50902899392807, 50902899425575] 
    }
  };
  
  for (const [venue, info] of Object.entries(venueMap)) {
    if (calendarProducts[venue]) {
      // このvenueのカレンダー付き商品を検索
      const items = cart.items.filter(item => info.variants.includes(item.variant_id));
      
      if (items.length > 0) {
        const totalQty = items.reduce((sum, item) => sum + item.quantity, 0);
        calendarItemsHTML.push(`
          <div style="padding: 10px; border-left: 4px solid #007bff; background-color: white; margin-bottom: 10px; border-radius: 4px;">
            <strong style="color: #007bff; font-size: 16px;">${info.name}</strong><br>
            <span style="color: #666; font-size: 14px; margin-top: 5px; display: inline-block;">カレンダー付き写真集 × ${totalQty}冊</span>
          </div>
        `);
      }
    }
  }
  
  if (calendarItemsHTML.length > 0) {
    listContainer.innerHTML = calendarItemsHTML.join('');
    infoContainer.style.display = 'block';
    console.log('✓ カレンダー付き商品情報を表示しました');
  } else {
    infoContainer.style.display = 'none';
  }
}

// ========================================
// 参加者名フォームの表示制御を更新する関数（会場名表示付き）
// ========================================
async function updateNameFormVisibility() {
  console.log('=== updateNameFormVisibility開始 ===');
  
  const calendarProducts = await detectCalendarProductsInCart();
  console.log('カレンダー付き商品の検出結果:', calendarProducts);
  
  // カレンダー付き商品の情報を表示
  await displayCalendarProductsInfo(calendarProducts);
  
  // ========================================
  // 岩岡徹（1日目）のフォーム
  // ========================================
  const iwaokaNameContainer = document.querySelector('.iwaoka-name-input-container');
  console.log('岩岡徹（1日目）コンテナ:', iwaokaNameContainer);
  
  const iwaokaVenues = [];
  
  if (window.venueQuantities['iwaoka-osaka'] > 0 || calendarProducts['iwaoka-osaka']) {
    iwaokaVenues.push('大阪会場');
  }
  if (window.venueQuantities['iwaoka-tokyo'] > 0 || calendarProducts['iwaoka-tokyo']) {
    iwaokaVenues.push('東京会場');
  }
  if (window.venueQuantities['iwaoka-fukuoka'] > 0 || calendarProducts['iwaoka-fukuoka']) {
    iwaokaVenues.push('福岡会場');
  }
  
  console.log('岩岡徹（1日目）会場リスト:', iwaokaVenues);
  
  const hasIwaoka = iwaokaVenues.length > 0;
  
  if (iwaokaNameContainer) {
    iwaokaNameContainer.style.display = hasIwaoka ? 'block' : 'none';
    
    const venueInfo = iwaokaNameContainer.querySelector('.venue-info');
    console.log('岩岡徹（1日目）.venue-info要素:', venueInfo);
    
    if (venueInfo) {
      if (hasIwaoka && iwaokaVenues.length > 0) {
        const venueText = `対象会場：${iwaokaVenues.join('、')}`;
        console.log('設定する会場テキスト:', venueText);
        venueInfo.textContent = venueText;
        venueInfo.style.display = 'block';
        console.log('✓ 会場名を表示しました:', venueInfo.textContent);
        console.log('✓ display:', venueInfo.style.display);
      } else {
        venueInfo.style.display = 'none';
      }
    } else {
      console.error('❌ .venue-info要素が見つかりません！');
      console.log('コンテナ内のHTML:', iwaokaNameContainer.innerHTML);
    }
    
    console.log(`✓ 岩岡徹（1日目）フォーム: ${hasIwaoka ? '表示' : '非表示'}`);
  }
  
  // ========================================
  // 岩岡徹（2日目）のフォーム
  // ========================================
  const iwaoka2NameContainer = document.querySelector('.iwaoka2-name-input-container');
  console.log('岩岡徹（2日目）コンテナ:', iwaoka2NameContainer);
  
  const iwaoka2Venues = [];
  
  if (window.venueQuantities['iwaoka2-osaka'] > 0 || calendarProducts['iwaoka2-osaka']) {
    iwaoka2Venues.push('大阪会場');
  }
  if (window.venueQuantities['iwaoka2-tokyo'] > 0 || calendarProducts['iwaoka2-tokyo']) {
    iwaoka2Venues.push('東京会場');
  }
  
  console.log('岩岡徹（2日目）会場リスト:', iwaoka2Venues);
  
  const hasIwaoka2 = iwaoka2Venues.length > 0;
  
  if (iwaoka2NameContainer) {
    iwaoka2NameContainer.style.display = hasIwaoka2 ? 'block' : 'none';
    
    const venueInfo = iwaoka2NameContainer.querySelector('.venue-info');
    console.log('岩岡徹（2日目）.venue-info要素:', venueInfo);
    
    if (venueInfo) {
      if (hasIwaoka2 && iwaoka2Venues.length > 0) {
        const venueText = `対象会場：${iwaoka2Venues.join('、')}`;
        console.log('設定する会場テキスト:', venueText);
        venueInfo.textContent = venueText;
        venueInfo.style.display = 'block';
        console.log('✓ 会場名を表示しました:', venueInfo.textContent);
      } else {
        venueInfo.style.display = 'none';
      }
    } else {
      console.error('❌ .venue-info要素が見つかりません！');
      console.log('コンテナ内のHTML:', iwaoka2NameContainer.innerHTML);
    }
    
    console.log(`✓ 岩岡徹（2日目）フォーム: ${hasIwaoka2 ? '表示' : '非表示'}`);
  }
  
  // ========================================
  // 和田颯のフォーム
  // ========================================
  const wadaNameContainer = document.querySelector('.wada-name-input-container');
  const wadaVenues = [];
  
  if (window.venueQuantities['wada-osaka'] > 0) {
    wadaVenues.push('大阪会場');
  }
  if (window.venueQuantities['wada-tokyo'] > 0) {
    wadaVenues.push('東京会場');
  }
  
  const hasWada = wadaVenues.length > 0;
  
  if (wadaNameContainer) {
    wadaNameContainer.style.display = hasWada ? 'block' : 'none';
    
    const venueInfo = wadaNameContainer.querySelector('.venue-info');
    if (venueInfo && hasWada && wadaVenues.length > 0) {
      venueInfo.textContent = `対象会場：${wadaVenues.join('、')}`;
      venueInfo.style.display = 'block';
      console.log(`✓ 和田颯会場名を表示: ${wadaVenues.join('、')}`);
    }
  }
  
  // ========================================
  // 大野雄大のフォーム
  // ========================================
  const ohnoNameContainer = document.querySelector('.ohno-name-input-container');
  const ohnoVenues = [];
  
  if (window.venueQuantities['ohno-osaka'] > 0) {
    ohnoVenues.push('大阪会場');
  }
  if (window.venueQuantities['ohno-tokyo'] > 0) {
    ohnoVenues.push('東京会場');
  }
  
  const hasOhno = ohnoVenues.length > 0;
  
  if (ohnoNameContainer) {
    ohnoNameContainer.style.display = hasOhno ? 'block' : 'none';
    
    const venueInfo = ohnoNameContainer.querySelector('.venue-info');
    if (venueInfo && hasOhno && ohnoVenues.length > 0) {
      venueInfo.textContent = `対象会場：${ohnoVenues.join('、')}`;
      venueInfo.style.display = 'block';
      console.log(`✓ 大野雄大会場名を表示: ${ohnoVenues.join('、')}`);
    }
  }
  
  console.log('=== updateNameFormVisibility完了 ===');
}


// ========================================
// DOMContentLoaded - 完全版
// ========================================

document.addEventListener("DOMContentLoaded", async function() {
  console.log('=== DOMContentLoaded開始 ===');
  
  const checkoutButton = document.getElementById("checkout-button");
  
  // グローバル変数の初期化
  window.venueQuantities = {};
  window.updateVenueProductInfo = updateVenueProductInfo;
  window.updateCartCounter = updateCartCounter;
  
  // 会場要素の初期化
  const venueElements = document.querySelectorAll('.venue-gifts');
  venueElements.forEach(element => {
    const venue = element.dataset.venue;
    if (venue) {
      window.venueQuantities[venue] = parseInt(element.dataset.quantity) || 0;
    }
  });
  
  console.log('初期化されたvenueQuantities:', window.venueQuantities);
  
  // ========================================
  // チケットのクリーンアップ（エラーがあっても続行）
  // ========================================
  try {
    await cleanupTicketsInCart();
  } catch (error) {
    console.warn('クリーンアップ処理でエラーが発生しましたが、処理を続行します。', error);
  }
  
  // ========================================
  // 初期化処理（クリーンアップの結果に関わらず実行）
  // ========================================
  try {
    await updateCartCounter();
  } catch (error) {
    console.warn('カートカウンター更新に失敗:', error);
  }
  
  try {
    await updateVenueProductInfo();
  } catch (error) {
    console.warn('会場商品情報更新に失敗:', error);
  }
  
  try {
    await preloadAllInventory();
  } catch (error) {
    console.warn('在庫情報の事前読み込みに失敗:', error);
  }
  
  enhanceInventoryDisplay();
  setupGiftButtons();
  setupNameInputs();
  
  // ========================================
  // 参加者名フォームの表示制御を初期化
  // ========================================
  try {
    await updateNameFormVisibility();
  } catch (error) {
    console.warn('参加者名フォーム表示制御に失敗:', error);
  }
  
  // ========================================
  // 15000円以上の参照番号フォームの初期化
  // ========================================
  try {
    await checkCartTotalAndShowForm();
  } catch (error) {
    console.warn('参照番号フォームの初期化に失敗:', error);
  }
  
  // ========================================
  // カート変更時の処理を拡張
  // ========================================
  const originalUpdateVenueProductInfo = window.updateVenueProductInfo;
  window.updateVenueProductInfo = async function() {
    await originalUpdateVenueProductInfo();
    try {
      await updateNameFormVisibility();
      await checkCartTotalAndShowForm();
    } catch (error) {
      console.warn('カート変更時の更新処理に失敗:', error);
    }
  };
  
  const originalUpdateCartCounter = window.updateCartCounter;
  window.updateCartCounter = async function() {
    await originalUpdateCartCounter();
    try {
      await checkCartTotalAndShowForm();
    } catch (error) {
      console.warn('カートカウンター更新時の処理に失敗:', error);
    }
  };
  
  // ========================================
  // 初期状態の設定
  // ========================================
  for (const venue of Object.keys(window.venueQuantities)) {
    if (window.venueQuantities[venue] > 0) {
      try {
        await updateButtonStates(venue);
      } catch (error) {
        console.warn(`${venue}のボタン状態更新に失敗:`, error);
      }
    }
  }
  
  // ========================================
  // カート変更監視
  // ========================================
  setupCartChangeDetection();

  // ========================================
  // チェックアウトボタンクリック時の処理
  // ========================================
  if (checkoutButton) {
    checkoutButton.addEventListener('click', async function(e) {
      e.preventDefault();

      try {
        // ボタンを無効化し処理中表示
        checkoutButton.disabled = true;
        checkoutButton.innerHTML = '<span class="spinner"></span> 処理中...';
        
        // スピナースタイルを追加
        if (!document.getElementById('spinner-styles')) {
          const style = document.createElement('style');
          style.id = 'spinner-styles';
          style.textContent = `
            .spinner {
              display: inline-block;
              width: 16px;
              height: 16px;
              border: 2px solid rgba(255,255,255,0.3);
              border-radius: 50%;
              border-top-color: #fff;
              animation: spin 1s ease-in-out infinite;
              margin-right: 8px;
            }
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `;
          document.head.appendChild(style);
        }

        // ========================================
        // 1. 商品の有無を確認（カレンダー付き商品も含む）
        // ========================================
        const calendarProducts = await detectCalendarProductsInCart();
        
        const hasGiftProducts = Object.keys(window.venueQuantities).some(venue => window.venueQuantities[venue] > 0);
        
        const hasIwaokaProducts = Object.keys(window.venueQuantities)
          .some(venue => venue.startsWith('iwaoka-') && window.venueQuantities[venue] > 0) ||
          calendarProducts['iwaoka-osaka'] ||
          calendarProducts['iwaoka-tokyo'] ||
          calendarProducts['iwaoka-fukuoka'];
          
        const hasIwaoka2Products = Object.keys(window.venueQuantities)
          .some(venue => venue.startsWith('iwaoka2-') && window.venueQuantities[venue] > 0) ||
          calendarProducts['iwaoka2-osaka'] ||
          calendarProducts['iwaoka2-tokyo'];
          
        const hasWadaProducts = Object.keys(window.venueQuantities)
          .some(venue => venue.startsWith('wada-') && window.venueQuantities[venue] > 0);
          
        const hasOhnoProducts = Object.keys(window.venueQuantities)
          .some(venue => venue.startsWith('ohno-') && window.venueQuantities[venue] > 0);
          
        const iwaokaNameInput = document.getElementById('iwaoka-representative-name');
        const iwaoka2NameInput = document.getElementById('iwaoka2-representative-name');
        const wadaNameInput = document.getElementById('wada-representative-name');
        const ohnoNameInput = document.getElementById('ohno-representative-name');
        
        // 特典商品もカレンダー付き商品もない場合は直接チェックアウトへ
        if (!hasGiftProducts && !Object.values(calendarProducts).some(v => v)) {
          window.location.href = "/checkout";
          return;
        }

        // ========================================
        // 2. 参加者名の検証（カレンダー付き商品も考慮）
        // ========================================
        let isNameValid = true;
        let nameErrorMessages = [];
        
        if (hasIwaokaProducts && iwaokaNameInput) {
          if (!validateName(iwaokaNameInput.value, true)) {
            isNameValid = false;
            nameErrorMessages.push('岩岡徹イベント（1日目）の参加者氏名をカタカナで入力してください。\n例：ヤマダ　タロウ');
          }
        }

        if (hasIwaoka2Products && iwaoka2NameInput) {
          if (!validateName(iwaoka2NameInput.value, true)) {
            isNameValid = false;
            nameErrorMessages.push('岩岡徹イベント（2日目）の参加者氏名をカタカナで入力してください。\n例：ヤマダ　タロウ');
          }
        }
        
        if (hasWadaProducts && wadaNameInput) {
          if (!validateName(wadaNameInput.value, true)) {
            isNameValid = false;
            nameErrorMessages.push('和田颯イベントの参加者氏名をカタカナで入力してください。\n例：ヤマダ　タロウ');
          }
        }
        
        if (hasOhnoProducts && ohnoNameInput) {
          if (!validateName(ohnoNameInput.value, true)) {
            isNameValid = false;
            nameErrorMessages.push('大野雄大イベントの参加者氏名をカタカナで入力してください。\n例：ヤマダ　タロウ');
          }
        }
        
        if (!isNameValid) {
          alert(nameErrorMessages.join('\n'));
          if (nameErrorMessages[0]?.includes('岩岡徹')) {
            if (nameErrorMessages[0]?.includes('1日目')) {
              iwaokaNameInput.focus();
            } else {
              iwaoka2NameInput.focus();
            }
          } else if (nameErrorMessages[0]?.includes('和田颯')) {
            wadaNameInput.focus();
          } else if (nameErrorMessages[0]?.includes('大野雄大')) {
            ohnoNameInput.focus();
          }
          checkoutButton.disabled = false;
          checkoutButton.innerHTML = 'チェックアウト';
          return;
        }

        // ========================================
        // 3. 特典選択の検証（残り冊数チェック）
        // ========================================
        let isValid = true;
        let errorMessages = [];

        for (const venue of Object.keys(window.venueQuantities)) {
          if (window.venueQuantities[venue] > 0) {
            const remaining = calculateRemaining(venue);
            if (remaining !== 0) {
              isValid = false;
              const [artist, location] = venue.split('-');
              const artistName = artist === 'iwaoka' ? '岩岡徹（1日目）' : 
                                 artist === 'iwaoka2' ? '岩岡徹（2日目）' : 
                                 artist === 'wada' ? '和田颯' : 
                                 artist === 'ohno' ? '大野雄大' : artist;
              const venueName = location === 'tokyo' ? '東京' : 
                                location === 'osaka' ? '大阪' : '福岡';
              errorMessages.push(`${artistName}の${venueName}会場の特典選択が完了していません（残り${remaining}冊分）`);
            }
          }
        }

        if (!isValid) {
          alert(errorMessages.join('\n'));
          checkoutButton.disabled = false;
          checkoutButton.innerHTML = 'チェックアウト';
          return;
        }

        // ========================================
        // 4. 選択した特典情報を収集
        // ========================================
        const selectedGifts = [];
        for (const venue of Object.keys(window.venueQuantities)) {
          if (window.venueQuantities[venue] > 0) {
            const [artist, location] = venue.split('-');
            const inputs = getVenueInputs(venue);
            
            for (const [key, input] of Object.entries(inputs)) {
              if (!input) continue;
              
              const value = parseInt(input.value) || 0;
              if (value > 0) {
                const type = key.replace('gift', '');
                selectedGifts.push({
                  artist,
                  location,
                  type,
                  quantity: value,
                  venue
                });
              }
            }
          }
        }
        
        // ========================================
        // 5. 在庫の事前チェック
        // ========================================
        checkoutButton.innerHTML = '<span class="spinner"></span> 在庫確認中...';
        const inventoryProblems = [];
        
        for (const gift of selectedGifts) {
          const { artist, location, type, quantity } = gift;
          const inventory = await checkGiftInventory(artist, location, type);
          
          if (!inventory.available || (inventory.managed && quantity > inventory.inventory)) {
            const artistName = artist === 'iwaoka' ? '岩岡徹（1日目）' : 
                               artist === 'iwaoka2' ? '岩岡徹（2日目）' : 
                               artist === 'wada' ? '和田颯' : 
                               artist === 'ohno' ? '大野雄大' : artist;
            const venueName = location === 'tokyo' ? '東京' : 
                              location === 'osaka' ? '大阪' : '福岡';
            
            inventoryProblems.push({
              ...gift,
              artistName,
              venueName,
              available: inventory.available,
              inventory: inventory.inventory
            });
          }
        }
        
        if (inventoryProblems.length > 0) {
          const errorMessages = inventoryProblems.map(item => {
            if (!item.available || item.inventory <= 0) {
              return `・${item.artistName}の${item.venueName}会場の${item.type}冊特典: 在庫切れです`;
            } else {
              return `・${item.artistName}の${item.venueName}会場の${item.type}冊特典: 在庫が足りません（選択:${item.quantity}、在庫:${item.inventory}）`;
            }
          });
          
          alert(`実際の在庫数を超えて選択されている特典があります:\n\n${errorMessages.join('\n')}\n\n特典はカートに追加されませんでした。\n\nページを更新して最新の在庫状況をご確認ください。`);
          window.location.reload();
          return;
        }

        // ========================================
        // 6. 既存のチケットを削除
        // ========================================
        checkoutButton.innerHTML = '<span class="spinner"></span> カート更新中...';
        await removeTicketsFromCart();

        // ========================================
        // 7. 新しいチケットの準備
        // ========================================
        const itemsToAdd = [];
        for (const gift of selectedGifts) {
          const { artist, location, type, quantity } = gift;
          const variantId = giftProductMapping[artist][location].variants[type];
          if (variantId) {
            itemsToAdd.push({
              id: variantId,
              quantity: quantity
            });
          }
        }

        // ========================================
        // 8. 参加者情報の保存とチケット追加
        // ========================================
        try {
          // 属性の初期化（古い属性を削除）
          const attributes = {
            '参加者氏名': '',
            '和田颯参加者氏名': ''
          };
          
          if (hasIwaokaProducts && iwaokaNameInput && iwaokaNameInput.value.trim()) {
            attributes['岩岡徹イベント参加者氏名（1日目）'] = iwaokaNameInput.value.trim();
          }
          if (hasIwaoka2Products && iwaoka2NameInput && iwaoka2NameInput.value.trim()) {
            attributes['岩岡徹イベント参加者氏名（2日目）'] = iwaoka2NameInput.value.trim();
          }
          if (hasWadaProducts && wadaNameInput && wadaNameInput.value.trim()) {
            attributes['和田颯イベント参加者氏名'] = wadaNameInput.value.trim();
          }
          if (hasOhnoProducts && ohnoNameInput && ohnoNameInput.value.trim()) {
            attributes['大野雄大イベント参加者氏名'] = ohnoNameInput.value.trim();
          }
          
          // ★★★ 会員番号を追加 ★★★
          const referenceNumberInput = document.getElementById('order-reference-number');
          if (referenceNumberInput && referenceNumberInput.value.trim()) {
            attributes['会員番号'] = referenceNumberInput.value.trim();
            console.log('会員番号を保存:', referenceNumberInput.value.trim());
          }
          
          // カート属性を更新
          const attributesResponse = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          });
          
          if (!attributesResponse.ok) {
            throw new Error('参加者情報の保存に失敗しました');
          }
          
          console.log('属性更新成功:', await attributesResponse.json());

          // チケットを追加
          if (itemsToAdd.length > 0) {
            checkoutButton.innerHTML = '<span class="spinner"></span> 特典追加中...';
            console.log("カートに追加する特典:", itemsToAdd);
            
            try {
              const ticketResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
              });

              if (!ticketResponse.ok) {
                const errorData = await ticketResponse.json();
                console.error("カート追加エラー:", errorData);
                
                // 詳細なエラー情報を生成
                let detailedErrorMessage = '特典の追加に失敗しました。\n\n';
                detailedErrorMessage += '【在庫状況の詳細】\n';
                
                // 各特典の現在の在庫状況を確認
                const stockDetails = [];
                for (const gift of selectedGifts) {
                  const artistName = gift.artist === 'iwaoka' ? '岩岡徹（1日目）' : 
                                     gift.artist === 'iwaoka2' ? '岩岡徹（2日目）' : 
                                     gift.artist === 'wada' ? '和田颯' : 
                                     gift.artist === 'ohno' ? '大野雄大' : gift.artist;
                  const venueName = gift.location === 'tokyo' ? '東京' : 
                                    gift.location === 'osaka' ? '大阪' : '福岡';
                  
                  // Liquidデータを優先的に使用
                  const variantId = giftProductMapping[gift.artist][gift.location].variants[gift.type];
                  let currentInventory;
                  
                  if (window.giftInventoryData && window.giftInventoryData[variantId]) {
                    const data = window.giftInventoryData[variantId];
                    currentInventory = {
                      available: data.available,
                      inventory: data.inventory,
                      managed: data.managed
                    };
                    console.log(`エラー時の在庫確認（Liquidデータ）: ${variantId} = ${data.inventory}個`);
                  } else {
                    currentInventory = await checkGiftInventory(gift.artist, gift.location, gift.type);
                    console.log(`エラー時の在庫確認（API）: ${variantId} = ${currentInventory.inventory}個`);
                  }
                  
                  stockDetails.push({
                    name: `${artistName}の${venueName}会場 ${gift.type}冊特典`,
                    requested: gift.quantity,
                    available: currentInventory.inventory,
                    isAvailable: currentInventory.available,
                    managed: currentInventory.managed
                  });
                }
                
                // エラーメッセージを構築
                let hasStockIssue = false;
                stockDetails.forEach(detail => {
                  if (!detail.isAvailable || detail.available <= 0) {
                    detailedErrorMessage += `\n❌ ${detail.name}\n`;
                    detailedErrorMessage += `   → 在庫切れです\n`;
                    hasStockIssue = true;
                  } else if (detail.managed && detail.requested > detail.available) {
                    detailedErrorMessage += `\n⚠️ ${detail.name}\n`;
                    detailedErrorMessage += `   → 選択数: ${detail.requested}個\n`;
                    detailedErrorMessage += `   → 現在庫: ${detail.available}個\n`;
                    detailedErrorMessage += `   → ${detail.requested - detail.available}個 超過しています\n`;
                    hasStockIssue = true;
                  } else {
                    detailedErrorMessage += `\n✓ ${detail.name}\n`;
                    detailedErrorMessage += `   → 選択数: ${detail.requested}個 / 在庫: ${detail.available}個\n`;
                  }
                });
                
                if (hasStockIssue) {
                  detailedErrorMessage += '\n特典はカートに追加されませんでした。\n';
                  detailedErrorMessage += '在庫が回復するまでお待ちいただくか、\n';
                  detailedErrorMessage += '選択数を減らして再度お試しください。';
                } else {
                  detailedErrorMessage += '\n予期しないエラーが発生しました。\n';
                  detailedErrorMessage += 'エラー詳細: ' + (errorData.description || errorData.message || '不明なエラー');
                  detailedErrorMessage += '\n\nページを更新して再度お試しください。';
                }
                
                throw new Error(detailedErrorMessage);
              }
              
              const addResult = await ticketResponse.json();
              console.log("特典追加結果:", addResult);
              
            } catch (addError) {
              throw addError;
            }
          }

          // ========================================
          // 9. 自動追加商品をカートに追加
          // ========================================
          checkoutButton.innerHTML = '<span class="spinner"></span> 追加商品を処理中...';
          
          // カート内のカレンダー付き商品をカウント
          const cart = await getCart();
          
          const osakaDay1CalendarVariants = [
            50894569013543, 50894569046311, 50894569079079,
            50894569111847, 50894569144615, 50894569177383
          ];
          
          const osakaDay2CalendarVariants = [
            50900113522983, 50900113555751, 50900113588519,
            50900113621287, 50900113654055, 50900113686823
          ];
          
          const tokyoDay1CalendarVariants = [
            50902703341863, 50902703374631, 50902703407399,
            50902703440167, 50902703472935, 50902703505703
          ];
          
          const tokyoDay2CalendarVariants = [
            50902781067559, 50902781100327, 50902781133095,
            50902781165863, 50902781198631, 50902781231399
          ];
          
          const fukuokaCalendarVariants = [
            50902899261735, 50902899294503, 50902899327271,
            50902899360039, 50902899392807, 50902899425575
          ];
          
          let osakaDay1CalendarCount = 0;
          let osakaDay2CalendarCount = 0;
          let tokyoDay1CalendarCount = 0;
          let tokyoDay2CalendarCount = 0;
          let fukuokaCalendarCount = 0;
          
          cart.items.forEach(item => {
            if (osakaDay1CalendarVariants.includes(item.variant_id)) {
              osakaDay1CalendarCount += item.quantity;
              console.log(`大阪1日目カレンダー付き商品を検出: ${item.title} (数量: ${item.quantity})`);
            } else if (osakaDay2CalendarVariants.includes(item.variant_id)) {
              osakaDay2CalendarCount += item.quantity;
              console.log(`大阪2日目カレンダー付き商品を検出: ${item.title} (数量: ${item.quantity})`);
            } else if (tokyoDay1CalendarVariants.includes(item.variant_id)) {
              tokyoDay1CalendarCount += item.quantity;
              console.log(`東京1日目カレンダー付き商品を検出: ${item.title} (数量: ${item.quantity})`);
            } else if (tokyoDay2CalendarVariants.includes(item.variant_id)) {
              tokyoDay2CalendarCount += item.quantity;
              console.log(`東京2日目カレンダー付き商品を検出: ${item.title} (数量: ${item.quantity})`);
            } else if (fukuokaCalendarVariants.includes(item.variant_id)) {
              fukuokaCalendarCount += item.quantity;
              console.log(`福岡カレンダー付き商品を検出: ${item.title} (数量: ${item.quantity})`);
            }
          });
          
          console.log(`大阪1日目カレンダー付き商品の合計: ${osakaDay1CalendarCount}個`);
          console.log(`大阪2日目カレンダー付き商品の合計: ${osakaDay2CalendarCount}個`);
          console.log(`東京1日目カレンダー付き商品の合計: ${tokyoDay1CalendarCount}個`);
          console.log(`東京2日目カレンダー付き商品の合計: ${tokyoDay2CalendarCount}個`);
          console.log(`福岡カレンダー付き商品の合計: ${fukuokaCalendarCount}個`);
          
          const autoAddItems = [];
          
          if (osakaDay1CalendarCount > 0 && AUTO_ADD_PRODUCTS['iwaoka-osaka']) {
            autoAddItems.push({
              id: AUTO_ADD_PRODUCTS['iwaoka-osaka'],
              quantity: osakaDay1CalendarCount
            });
            console.log(`大阪1日目の自動追加商品(ポストカード): ${osakaDay1CalendarCount}個を追加`);
          }
          
          if (osakaDay2CalendarCount > 0 && AUTO_ADD_PRODUCTS['iwaoka2-osaka']) {
            autoAddItems.push({
              id: AUTO_ADD_PRODUCTS['iwaoka2-osaka'],
              quantity: osakaDay2CalendarCount
            });
            console.log(`大阪2日目の自動追加商品(ポストカード): ${osakaDay2CalendarCount}個を追加`);
          }
          
          if (tokyoDay1CalendarCount > 0 && AUTO_ADD_PRODUCTS['iwaoka-tokyo']) {
            autoAddItems.push({
              id: AUTO_ADD_PRODUCTS['iwaoka-tokyo'],
              quantity: tokyoDay1CalendarCount
            });
            console.log(`東京1日目の自動追加商品(ポストカード): ${tokyoDay1CalendarCount}個を追加`);
          }
          
          if (tokyoDay2CalendarCount > 0 && AUTO_ADD_PRODUCTS['iwaoka2-tokyo']) {
            autoAddItems.push({
              id: AUTO_ADD_PRODUCTS['iwaoka2-tokyo'],
              quantity: tokyoDay2CalendarCount
            });
            console.log(`東京2日目の自動追加商品(ポストカード): ${tokyoDay2CalendarCount}個を追加`);
          }
          
          if (fukuokaCalendarCount > 0 && AUTO_ADD_PRODUCTS['iwaoka-fukuoka']) {
            autoAddItems.push({
              id: AUTO_ADD_PRODUCTS['iwaoka-fukuoka'],
              quantity: fukuokaCalendarCount
            });
            console.log(`福岡の自動追加商品(ポストカード): ${fukuokaCalendarCount}個を追加`);
          }
          
          // 自動追加商品をカートに追加
          if (autoAddItems.length > 0) {
            console.log("自動追加商品をカートに追加:", autoAddItems);
            
            try {
              const autoAddResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: autoAddItems })
              });
              
              if (!autoAddResponse.ok) {
                const errorData = await autoAddResponse.json();
                console.error("自動追加商品のカート追加エラー:", errorData);
                console.warn("自動追加商品の追加に失敗しましたが、処理を続行します");
              } else {
                const autoAddResult = await autoAddResponse.json();
                console.log("自動追加商品の追加成功:", autoAddResult);
              }
            } catch (autoAddError) {
              console.error("自動追加商品の追加中にエラー:", autoAddError);
            }
          } else {
            console.log("カート内にカレンダー付き商品がないため、自動追加商品はスキップします");
          }

          // ========================================
          // 10. カート数量を更新
          // ========================================
          await updateCartCounter();
          await updateVenueProductInfo();

          // ========================================
          // 11. 最終チェック
          // ========================================
          checkoutButton.innerHTML = '<span class="spinner"></span> 最終確認中...';
          const finalCart = await getCart();
          const ticketVariantIds = selectedGifts.map(g => 
            giftProductMapping[g.artist][g.location].variants[g.type].toString()
          );
          
          const addedTickets = finalCart.items.filter(item => 
            ticketVariantIds.includes(item.variant_id.toString())
          );
          
          if (addedTickets.length !== ticketVariantIds.length) {
            throw new Error("特典が正しく追加されませんでした。もう一度お試しください。");
          }

          // ========================================
          // 12. チェックアウトページへ遷移
          // ========================================
          window.location.href = "/checkout";
          
        } catch (error) {
          // エラーメッセージを表示してリロード
          let errorMessage = error.message || '特典の追加に失敗しました';
          alert(errorMessage);
          window.location.reload();
          return;
        }
        
      } catch (error) {
        console.error("Debug - エラー発生:", error);
        alert('予期せぬエラーが発生しました。ページを更新します。');
        window.location.reload();
        return;
      }
    });
  }

  // ========================================
  // 同意チェックボックスの処理
  // ========================================
  const agreeCheckbox = document.getElementById('agree');
  const cartBtn = document.querySelector('.malin-cartBtn');
  
  if (agreeCheckbox && cartBtn) {
    agreeCheckbox.addEventListener('click', function() {
      cartBtn.classList.toggle('active');
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

$(document).ready(function () {

$('.product__media-list').slick(getSliderSettings());

$('.product__media-sublist').slick(getSubSliderProductSettings());
});


  } catch(e) { console.error(e); }
})();
})();
